import {useEffect, useRef} from 'react'
import {copilotLocalStorage} from '@github-ui/copilot-chat-helpers/copilot-local-storage'
import {submitTask} from '../utils/submit-task'
import type {HandleUserSubmit} from '@github-ui/one-copilot-composer/user-submit'
/**
 * Custom hook that processes task entrypoint messages from local storage
 * and triggers task creation or chat submission on mount.
 *
 * @param handleUserSubmit - Callback function to handle task/message submission
 */
export function useTaskEntrypoint(handleUserSubmit: HandleUserSubmit) {
  const handleUserSubmitRef = useRef(handleUserSubmit)

  useEffect(() => {
    handleUserSubmitRef.current = handleUserSubmit
  }, [handleUserSubmit])

  useEffect(() => {
    const entrypointMessage = copilotLocalStorage.getTaskEntrypointMessage()
    if (entrypointMessage) {
      copilotLocalStorage.setTaskEntrypointMessage(null)

      submitTask(entrypointMessage.message, handleUserSubmitRef)
    }
  }, [])
}
